/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc
 */

export const getApprovalConfigurationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovalConfiguration',
  auth: 'app',
  fingerprint: '5raw4qLtibeUDooKd2RULoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApproversRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovers',
  auth: 'app',
  fingerprint: 'MQXgpSUgriCv1wchydvePIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const putApprovalConfigurationRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putApprovalConfiguration',
  auth: 'app',
  fingerprint: 'ffQ6oUW6CPaG4dATOqDviYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendRequestToEnableApprovalsRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'sendRequestToEnableApprovals',
  auth: 'app',
  fingerprint: 'vzjBIqVUnjW_GCjzXfbQCYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};